import Tag from '../Tag'
import {
  SelectList
} from 'UI'
import Text from './text.json'
import { useEffect, useState } from 'react'
import { cleanTag } from '../store'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyle = createUseStyles(style)

const skeletonTagsLength = 8

export default ({ categories = [], selectedFreeCoursesTag, handleTagClick, selectList, selectedCategory, loading }) => {
  const [showMore, setShowMore] = useState(false)
  useEffect(() => {
    setShowMore(false)
  }, [selectedCategory])
  const filteredCategories = categories.filter((category) => category?.TotalFreeCourses > 0)
  const tagsToShow = loading ? [...Array(skeletonTagsLength).fill(true)] : filteredCategories

  const { tagsRow } = useStyle()

  return selectList
    ? (
      <SelectList
        idField='Id'
        valueField='Name'
        items={filteredCategories}
        onSelectedItem={(tag) => handleTagClick(selectedFreeCoursesTag?.Id === tag.Id ? cleanTag : tag)}
        selectedItem={selectedFreeCoursesTag.Id ? selectedFreeCoursesTag.Name : Text.subCategories}
        selectedLabel={selectedFreeCoursesTag.Id ? `${selectedFreeCoursesTag.Name} (${selectedFreeCoursesTag.TotalFreeCourses})` : Text.subCategories}
        gutterBottom={24}
      />
      )
    : (
      <div className={tagsRow}>
        {showMore
          ? tagsToShow
          : tagsToShow.map((tag, key) =>
            <Tag
              loading={loading}
              key={tag?.Id || key}
              {...tag}
              NumberOfCourses={tag?.TotalFreeCourses}
              active={selectedFreeCoursesTag?.Id === tag?.Id}
              handleTagClick={(tag) => {
                handleTagClick(selectedFreeCoursesTag?.Id === tag.Id ? cleanTag : tag)
              }}
            />
          )}
        {tagsToShow.length > 10
          ? <Tag
              active={showMore}
              handleTagClick={() => setShowMore(!showMore)}
              Name={showMore ? Text.showLess : Text.showMore}
            />
          : null}
      </div>
      )
}
